import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, styled } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { ICONS, unit } from '@hcr/ui'

import { COLORS } from '../../../../../../../../../libs/ui/src/lib/constants'
import { Drawer } from '../../../../drawer'

type NavigationMenuDrawerProps = PropsWithChildren & { isVisble: boolean; setIsVisble: (isVisble: boolean) => void }

export const NavigationMenuDrawer: FC<NavigationMenuDrawerProps> = ({ children, setIsVisble, isVisble }) => {
  const { t } = useTranslation()

  return (
    <Drawer
      paddingX={unit(3.5)}
      paddingBottom={unit(4)}
      paddingTop={unit(4)}
      onClose={() => setIsVisble(false)}
      disablePortal={true}
      sx={{
        position: 'absolute',
        '& .MuiDrawer-paper': {
          position: 'absolute',
          boxSizing: 'border-box',
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            opacity: '0.2 !important',
          },
        },
      }}
      PaperProps={{
        sx: theme => ({
          backgroundColor: COLORS.vaalea[400],
          width: unit(93.75),
          padding: 0,
          top: unit(18),
          left: 'auto',
          height: 'auto',

          [theme.breakpoints.down('lg')]: {
            '& .MuiDrawer-paper': {
              position: 'absolute',
              boxSizing: 'border-box',
            },
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            '& > div': {
              flexGrow: 1,
              height: 'auto',
            },
          },
          [theme.breakpoints.up('lg')]: {
            right: unit(8.5),
          },
          [theme.breakpoints.up('xl')]: {
            right: unit(36),
          },
        }),
      }}
      open={isVisble}
    >
      <Box
        role='dialog'
        aria-modal='true'
        aria-labelledby='modal-title'
        sx={theme => ({
          flexGrow: 1,
          [theme.breakpoints.down('lg')]: {
            width: '100%',
            height: '100%',
            top: 0,
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
          },
        })}
        bgcolor={COLORS.vaalea['60%']}
      >
        <Box
          display='flex'
          justifyContent='end'
          alignItems='center'
          height={unit(13.5)}
          paddingTop={unit(2.5)}
          paddingRight={unit(2)}
        >
          <Button
            sx={{
              height: unit(11),
              width: unit(11),
              minWidth: 'unset',
              '&:hover': {
                backgroundColor: 'inherit',
                boxShadow: 'none',
              },
            }}
            onClick={() => setIsVisble(false)}
            aria-label={t('navigation.close-menu')}
          >
            <Icon icon={ICONS.farXmark} aria-hidden={true} />
          </Button>
        </Box>
        {children}
      </Box>
    </Drawer>
  )
}

const Icon = styled(FontAwesomeIcon)`
  color: ${COLORS.black};
  text-align: center;
  font-size: ${unit(6)};
  line-height: ${unit(4)};
  height: ${unit(4)};
  width: ${unit(3.75)};
`
